import axios from "axios";
import { getAccessTokenAsync } from "@kamstrup/flow-core/security";
import { getEnv } from "src/config/index";
import { getServices } from "src/logs";

const { logger } = getServices();

const baseURL =
  getEnv().REACT_APP_LEAK_API_V1_URL ||
  (() => {
    logger.logError({ message: "REACT_APP_BACKEND_URL environmental variable not set" });
    throw new Error("REACT_APP_LEAK_API_V1_URL environmental variable not set");
  })();

const LeakdetectorBFF = axios.create({
  baseURL
});

LeakdetectorBFF.interceptors.request.use(async (config) => {
  const scopes = [getEnv().REACT_APP_ANALYTICS_ACCESS_TOKEN_SCOPE || ""];

  try {
    const accessToken = await getAccessTokenAsync(scopes);

    if (!accessToken) {
      logger.logWarning({ message: "LeakdetectorBFF accessToken is empty" });
    }

    config.headers.Authorization = `Bearer ${accessToken}`;
  } catch (error) {
    // Log any errors related to getting the access token
    const tokenErrorMessage = "LeakdetectorBFF Access Token Error";
    const scopeString = scopes.join(", ");
    if (error instanceof Error) {
      // Log any errors related to getting the access token
      logger.logError({
        message: tokenErrorMessage,
        properties: {
          errorName: error.name,
          errorMessage: error.message,
          errorStack: error.stack || "unknown stack",
          errorCause: String(error.cause ?? "unknown cause")
        }
      });
    } else if (error instanceof String) {
      logger.logError({ message: error.toString(), properties: { scopes: scopeString } });
    } else {
      logger.logError({
        message: `Unknown error type : ${tokenErrorMessage}`,
        properties: { scopes: scopeString }
      });
    }
  }

  return config;
});

LeakdetectorBFF.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error) => {
    // Log error responses
    const err = error as Error;
    logger.logError({
      message: "LeakDetectorBFF - Exception",
      properties: {
        name: err.name,
        message: err.message,
        stack: err.stack || "unknown stack",
        cause: String(err.cause ?? "unknown cause")
      }
    });
    return Promise.reject(error);
  }
);

export { LeakdetectorBFF };

